

















import {getMenus} from '@/api/menu'
import {Component, Vue, Provide} from 'vue-property-decorator'

@Component
export default class PageHeader extends Vue {
    @Provide() title: any = ''
    @Provide() menus: any = []

    get breadcrumbs() {
        let breadcrumbs: any[] = []
        this.menus.forEach((item: any) => {
            if (item.items) {
                let child = item.items.find((i: any) => {
                    return i.menuCode === this.$route.name
                })
                if (child) {
                    breadcrumbs.push(item.menuName)
                    breadcrumbs.push(child.menuName)
                    this.title = child.menuName
                }
            } else {
                if (item.menuCode === this.$route.name) {
                    this.title = item.menuName
                    breadcrumbs.push(item.menuName)
                }
            }
        })

        return breadcrumbs
    }

    mounted() {
        this.getMenusFromApi()
    }

    getMenusFromApi() {
        return getMenus().then((data: any) => {
            this.menus = data
        })
    }

    refresh() {
        const url = this.$route.path
        console.log(url)
        this.$router.push(url)
    }
}
